module.exports = __webpack_public_path__ + "media/images/font/SofiaPro-Bold-fc9ad71e864e50ea2995595e7d54ea30.woff2";